import React from 'react';
import * as Mapbox from "react-map-gl/mapbox";
import {LayerSpecification, SymbolLayerSpecification} from "mapbox-gl";
import {MapLayer} from "../../../types/MapLayers";

// Types ----

type BeaconLayerProps = {
  source?: string
  enabledLayers: MapLayer[]
}

// Component ----

function BeaconLayer({source = '', enabledLayers}: BeaconLayerProps) {

  const beaconFilter = ["==", "type", "beacon"];
  const layout: LayerSpecification['layout'] = { visibility: enabledLayers.includes(MapLayer.BEACON) ? "visible" : "none" };

  return (
    <Mapbox.Layer
      type="symbol"
      id="ngage-beacon"
      source={source}
      filter={beaconFilter}
      layout={{...beaconLayout, ...layout}}
      paint={beaconPaint}
    />
  );
}

// Styles ----

const beaconLayout: SymbolLayerSpecification['layout'] = {
  "icon-image": "ngage-pin-beacon",
  "icon-size": 0.6,
  "icon-anchor": "bottom",
  "icon-keep-upright": true,
  "icon-allow-overlap": true,
  "text-field": ["get", "name"],
  "text-anchor": "top",
}

const beaconPaint: SymbolLayerSpecification['paint'] = {
  "text-halo-width": 1,
  "text-halo-color": "#FFFFFF",
  "text-halo-blur": 1
}

export default BeaconLayer;